import { initialSearchState, SearchState } from 'contexts/SearchContext';
import { SearchAction, SearchActionType } from 'contexts/SearchActions';

const searchReducer = (state: SearchState, action: SearchAction): typeof initialSearchState => {
    switch (action.type) {
        case SearchActionType.Init: {
            return {
                ...state,
                initialised: true
            };
        }
        case SearchActionType.SetArea: {
            const { area } = action;
            return {
                ...state,
                area
            };
        }
        case SearchActionType.SetCategory: {
            const { category } = action;
            return {
                ...state,
                category
            };
        }
        case SearchActionType.SetUrl: {
            const { url } = action;
            return {
                ...state,
                url
            };
        }
        case SearchActionType.SetPage: {
            const { currentPage } = action;
            return {
                ...state,
                currentPage
            };
        }
        case SearchActionType.SetAllFilters: {
            const { filters } = action;
            return {
                ...state,
                availableFilters: filters
            };
        }
        case SearchActionType.SetFilters: {
            const { filters } = action;
            return {
                ...state,
                filters
            };
        }
        case SearchActionType.SetMapView: {
            const { mapView } = action;
            return {
                ...state,
                mapView
            };
        }
        case SearchActionType.SetAllSorts: {
            const { sorts } = action;
            return {
                ...state,
                availableSorts: sorts
            };
        }
        case SearchActionType.SetSort: {
            const { sort } = action;
            return {
                ...state,
                sort
            };
        }
        case SearchActionType.SetSortDirection: {
            const { direction } = action;
            return {
                ...state,
                sortDirection: direction
            };
        }
        case SearchActionType.SetResults: {
            const { results } = action;
            return {
                ...state,
                results
            };
        }

        case SearchActionType.SetMapResults: {
            const { results } = action;
            return {
                ...state,
                mapResults: results
            };
        }

        case SearchActionType.SetLoading: {
            const { loading } = action;
            return {
                ...state,
                isLoading: loading
            };
        }

        case SearchActionType.ResetParams: {
            return {
                ...state,
                category: null,
                area: null,
                filters: [],
                sort: null,
                sortDirection: 'ASC',
                currentPage: 1
            };
        }

        default: {
            return { ...state };
        }
    }
};

export default searchReducer;
